export default __webpack_public_path__ + "static/20210831_153548_cropped-f5107e4554f46d90b76d70d96aae6367.jpg";